<template>
    <Mikomi_Type v-for="keikaku in MikomiMonthData.Keikaku" :key="keikaku" :TeamFilter="TeamFilter" :MikomiTypeData="keikaku.Data" :MonthLabel="GetMonthLabel()" :CellTitlePrefix="KeikakuCellTitlePrefix(keikaku)" :CellColor="KeikakuCellColor(keikaku)" />
    <template v-if="ShowEstimation()">
        <Mikomi_Type :MikomiTypeData="MikomiMonthData.Estimation" :TeamFilter="TeamFilter" :IsEstimation="true" :MonthLabel="GetMonthLabel()" :CellTitlePrefix="'見込 '" :CellColor="'#DAEEF3'" />
    </template>
    <template v-else>
        <Mikomi_Type :MikomiTypeData="MikomiMonthData.Result" :TeamFilter="TeamFilter" :IsResult="true" :MonthLabel="GetMonthLabel()" :CellTitlePrefix="'実績 '" :CellColor="'#DAEEF3'" />
    </template>
    <Mikomi_Type :MikomiTypeData="MikomiMonthData.Difference" :TeamFilter="TeamFilter" :IsDifference="true" :MonthLabel="GetMonthLabel()" :CellTitlePrefix="'差額 '" :CellColor="'#FFFFFF'" />
    <div style="margin-right: 1px;"></div>
</template>

<script>
import Mikomi_Type from './Mikomi_Type.vue';
export default{
    components:{
        Mikomi_Type,
    },
    props:{
        MikomiMonthData: Object,
        CurrentMonth: Number,
        TeamFilter: Array,
    },
    methods:{
        ShowEstimation()
        {
            if (this.MikomiMonthData.IsQuarter === true)
            {
                if (this.MikomiMonthData.Quarter === 4)
                {
                    return true;
                }
                else if (this.MikomiMonthData.Quarter === 3)
                {
                    return this.CurrentMonth <= 9;
                }
                else if (this.MikomiMonthData.Quarter === 2)
                {
                    return this.CurrentMonth <= 6;
                }
                else if (this.MikomiMonthData.Quarter === 1)
                {
                    return this.CurrentMonth <= 3;
                }
            }
            else if (this.MikomiMonthData.IsHalfYear === true)
            {
                return this.MikomiMonthData.Quarter === 1 ? this.CurrentMonth <= 6 : true;
            }
            else if (this.MikomiMonthData.Month === -1)
            {
                return true;
            }
            else
            {
                return this.MikomiMonthData.Month >= this.CurrentMonth;
            }
        },
        KeikakuCellTitlePrefix(keikaku)
        {
            switch(keikaku.Revision)
            {
                case 0: return '計画 ';
                case 1: return '3月見直計画 ';
                case 2: return '6月見直計画 ';
                case 3: return '9月見直計画 ';

                default: return '';
            } 
        },
        KeikakuCellColor(keikaku)
        {
            switch(keikaku.Revision)
            {
                case 0: return '#D8E4BC';
                case 1: return '#FDE9D9';
                case 2: return '#E4DFEC';
                case 3: return '#FFFF99';

                default: '#FF9900';
            } 
        },
        GetMonthLabel()
        {
            if (this.MikomiMonthData.IsQuarter === true)
            {
                return `Q${this.MikomiMonthData.Quarter}`;
            }
            else if (this.MikomiMonthData.IsHalfYear === true)
            {
                if (this.MikomiMonthData.Quarter === 1)
                {
                    return `上期`;
                }
                else
                {
                    return `下期`;
                }
            }
            else if (this.MikomiMonthData.Month === -1)
            {
                return `年間`;
            }
            else
            {
                return `${this.MikomiMonthData.Month}月`;
            }
        }
    },
    // created(){
    //     if (this.MikomiMonthData.IsQuarter === true &&
    //         this.MikomiMonthData.Quarter === 1)
    //     {
    //         console.log('[Mikomi_Month] Current month: ' + this.CurrentMonth + ' Show estimation: ' + (this.MikomiMonthData.Month >= this.CurrentMonth), this.MikomiMonthData);
    //     }
    // }
}
</script>